export default __webpack_public_path__ + "static/media/100t.f617dc16.jpg";